import { Component, OnInit } from '@angular/core';
import { PuntoEquilibrioService } from './punto-equilibrio.service';
import { LoginService } from '../../../login/login.service';
import Swal from 'sweetalert2';

import { PeriodoEjercicioService } from '../../../control/periodo.service';
@Component({
  selector: 'app-punto-equilibrio',
  templateUrl: './punto-equilibrio.component.html',
  styleUrls: ['./punto-equilibrio.component.css'],
  preserveWhitespaces: true,
  providers: [PuntoEquilibrioService, LoginService]
})
export class PuntoEquilibrioComponent implements OnInit {
  public anos: any[] = [];
  public ano: number;
  public mes: number;
  public frecuencia: number;
  public items_periodos: any[] = [];
  public reporte: any = {};
  public cargado: boolean;
  public frecuencia_1: any[] = [
    {numero: 1 , nombre: 'enero'},
    {numero: 2, nombre: 'febrero'},
    {numero: 3, nombre: 'marzo'},
    {numero: 4, nombre: 'abril'},
    {numero: 5, nombre: 'mayo'},
    {numero: 6, nombre: 'junio'},
    {numero: 7, nombre: 'julio'},
    {numero: 8, nombre: 'agosto'},
    {numero: 9, nombre: 'septiembre'},
    {numero: 10, nombre: 'octubre'},
    {numero: 11, nombre: 'noviembre'},
    {numero: 12, nombre: 'diciembre'},
    {numero: 13, nombre: 'periodo_ajuste'}];

  public frecuencia_2: any[] = [
  {numero: 1 , nombre: 'enero_febrero'},
  {numero: 2, nombre: 'marzo_abril'},
  {numero: 3, nombre: 'mayo_junio'},
  {numero: 4, nombre: 'julio_agosto'},
  {numero: 5, nombre: 'septiembre_octubre'},
  {numero: 6, nombre: 'noviembre_diciembre'}];

  public frecuencia_3: any[] = [
  {numero: 1 , nombre: 'enero_marzo'},
  {numero: 2, nombre: 'abril_junio'},
  {numero: 3, nombre: 'julio_septiembre'},
  {numero: 4, nombre: 'octubre_diciembre'}];

  constructor(private loginService: LoginService, private service: PuntoEquilibrioService, private PeriodoEjercicioService: PeriodoEjercicioService) {
    const ejercicios = JSON.parse(localStorage.getItem('ejercicios'));
    for (let x = 0; x < ejercicios.length; x++) {
      this.anos.push(ejercicios[x].anio);
    }
         this.PeriodoEjercicioService.ejercicio$.subscribe(ejercicio => {
      this.ano = ejercicio ? ejercicio : 0;

    });
    this.PeriodoEjercicioService.periodo$
      .subscribe(periodo => {

        this.mes = periodo ? periodo : 13;
      });
    this.frecuencia = 1;
    this.setFrecuencia();
    //this.cargarDatos();
   }

  ngOnInit(): void {
  }
  cargarDatos() {
    this.mostrarMensajeCarga('Se está generando tu reporte');
    this.service.getF(this.loginService.empresa, this.frecuencia, this.mes, this.ano).subscribe(
      response => {
        this.reporte = response.contenido;
        this.cerrarMensajeCarga();
      }, err => {
      this.cerrarMensajeCarga();
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
        console.log(err);
      }
    );
  }
  exportAsPDF() {
    this.service.getPdf(this.loginService.empresa, this.frecuencia, this.mes, this.ano).subscribe(
      response => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(response);
        a.download = this.loginService.empresa_info_actual.titulo.toLowerCase().replace(/\s+/g, '_') + '_punto_de_equilibrio' +
        (this.frecuencia == 1 ? '_' + this.frecuencia_1[this.mes].nombre :
        (this.frecuencia == 2 ? '_' + this.frecuencia_2[this.mes].nombre :
        (this.frecuencia == 3 ? '_' + this.frecuencia_3[this.mes].nombre : ''))) + '_' + this.ano + '.pdf';

        document.body.appendChild(a);
        a.click();
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
        console.log(err);
      }
    );
  }
  exportAsXLSX() {
    this.service.getXlsx(this.loginService.empresa, this.frecuencia, this.mes, this.ano).subscribe(
      response => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(response);
        a.download = this.loginService.empresa_info_actual.titulo.toLowerCase().replace(/\s+/g, '_') + '_punto_de_equilibrio' +
        (this.frecuencia == 1 ? '_' + this.frecuencia_1[this.mes].nombre :
        (this.frecuencia == 2 ? '_' + this.frecuencia_2[this.mes].nombre :
        (this.frecuencia == 3 ? '_' + this.frecuencia_3[this.mes].nombre : ''))) + '_' + this.ano + '.xlsx';

        document.body.appendChild(a);
        a.click();
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
        console.log(err);
      }
    );
  }

  setFrecuencia() {
    this.mes = 1;
    this.items_periodos = [];
    if (this.frecuencia == 1) {
      for (let x = 0; x < 12; x++) {
        this.items_periodos.push(x + 1);
      }
    }
    if (this.frecuencia == 2) {
    for (let x = 0; x < 6; x++) {
      this.items_periodos.push(x + 1);
    }
    }
    if (this.frecuencia == 3) {
      for (let x = 0; x < 4; x++) {
        this.items_periodos.push(x + 1);
      }
    }
    if (this.frecuencia == 6) {
      for (let x = 0; x < 2; x++) {
        this.items_periodos.push(x + 1);
      }
    }
    if (this.frecuencia == 12) {
      for (let x = 0; x < 1; x++) {
        this.items_periodos.push(x + 1);
      }
    }
    this.cargarDatos();
  }

  mostrarMensajeCarga(mensaje: string) {
    this.cargado = false;
    const numeros = [1, 2, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6];
    const aleatorio = numeros[Math.floor(Math.random() * numeros.length)];
    Swal.fire({
      html: `
      <div style="text-align: center">
        <h4><img src="/assets/gif/loading` + aleatorio + `.gif" width="80"/>
        <br><br><strong>Por favor espere...</strong><br><small>` + mensaje + `</small></h4>
      </div>`,
      toast: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
